import { PipeTransform, Pipe } from '@angular/core';
import  * as moment from "moment";
import { Observable } from "rxjs/Observable";
import { Observer } from "rxjs/Observer";

@Pipe({name: 'dateTime'})
export class DateTimePipe implements PipeTransform {
  
  static MINUTE_SECONDS = 60;
  static HOUR_SECONDS = DateTimePipe.MINUTE_SECONDS * 60;
  static DAY_SECONDS = DateTimePipe.HOUR_SECONDS * 24;
  
  constructor(){
    moment.locale('nl'); 
  }
  
  transform(value: string, format: string = 'relative'): string|Observable<string> {
    
    let parsed;
    const momentValue = moment(value);
    
    if (format === 'relative') {
      //async
            
      return new Observable<string>((observer: Observer<string>) => {      
        
        parsed = momentValue.fromNow();
        
        //First hit
        observer.next(parsed);
        
        //Set timeout for next hits (recursive)
        this.setObserverTimeout(observer, momentValue);
        
      });
    }
    
    else {
      //Non async
      if (format === 'long') {
        parsed = momentValue.format("D MMMM YYYY HH:mm");
      }
      else if (format === 'short') {
        parsed = momentValue.format("DD-MM-YYYY HH:mm");
      }
      else {
        parsed = momentValue.format(format);
      }
      return parsed;
    }
    
  }
  
  
  private setObserverTimeout(observer, momentValue){
    
    let now = moment();
    let diffSeconds = now.diff(momentValue, 'seconds');
    let timeOutSeconds;
    
    if(diffSeconds < DateTimePipe.MINUTE_SECONDS) {
      //Time is within a minute ago, update every 20 seconds
      timeOutSeconds = 20;
    }
    else if(diffSeconds < DateTimePipe.HOUR_SECONDS) {
      //Time is within an hour ago, update every minute
      timeOutSeconds = DateTimePipe.MINUTE_SECONDS;
    }
    else if(diffSeconds < DateTimePipe.DAY_SECONDS) {
      //Time is within an day ago, update every 20 min
      timeOutSeconds = 20 * DateTimePipe.MINUTE_SECONDS;          
    }
    else {
      //Time is more than an day ago, update every 60 min
      timeOutSeconds = DateTimePipe.HOUR_SECONDS;   
    }
        
    setTimeout(()=>{
      
      let parsed = momentValue.fromNow();      
      observer.next(parsed);      
      this.setObserverTimeout(observer, momentValue);
      
    }, timeOutSeconds * 1000);
    
  }
}



// WEBPACK FOOTER //
// ./src/pipes/dateTime.ts